<template>
  <div ref="tableRef" v-loading="loading" :class="{
    'rt-table--border': showBorder,
    'rt-table--no-footer': !hasFooter,
    'is-radio': radio,
    'is-sticky': isSticky
  }" class="rt-table">
    <div v-if="hasHeader" ref="tableHeaderRef" :style="headerStyle" class="rt-table-header">
      <slot name="header"></slot>
      <div class="rt-table-header__left">
        <slot name="header-left">
        </slot>
      </div>
      <div class="rt-table-header__right">
        <slot name="header-right">
        </slot>
      </div>
      <div class="rt-table-header__center">
        <slot name="header-center">
        </slot>
      </div>
    </div>
    <div ref="tableContentRef" :class="['is-' + size]" class="rt-table-content">
      <!-- autoHeight {{  autoHeight}} --
      headrFilter {{  headrFilter}}--
      needFetch {{  needFetch}} -- -->
      <el-table ref="table" v-bind="$attrs" :stripe="stripe" v-if="autoHeight && needFetch &&headrFilter" :data="dataList" :row-key="rowKey"
        :row-class-name="rowClassNameFn" :cell-class-name="cellClassNameFn" :header-row-class-name="headerCls"
        :border="showBorder" :class="['rt-table-item', { 'rt-table-draggable': draggable }]" :header-sticky="isSticky"
        :loading="loading" :show-fix-columns="showFixColumns" :radio="radio" :empty-text="emptyText"
        :total-record="totalRecord" :optimize-fixed="optimizeFixed" v-on="$listeners" @row-click="handleClickTableRow"
        @row-dblclick="rowDblclickHandler" @selection-change="selectItem" @cell-click="handleCellClick"
        :height="tableHeight" @header-dragend="changeColWidth">
        <!-- 勾选框列 -->
        <el-table-column v-if="computedSelected" type="selection" :reserve-selection="computedKeepSelected" width="48"
          @selection-change="handleSelectionChange" />
        <!-- 序号列 -->
        <!-- <el-table-column label="序号" type="index" width="50" fixed>
        </el-table-column> -->
        
        <!-- 表头列 -->
        <template v-for="(item, index) in tableHeader">
         
          <el-table-column :prop="item.prop" :label="item.label" min-width="20" :width="item.width?item.width:'auto'" show-overflow-tooltip>
            <template slot="header" slot-scope="scope"> 
              <div @mouseover="onMouseOver('refName' + item.prop)" :ref="'refParentName' + item.prop"
                :id="'refParentName' + item.prop" class="refParentStyle">
                <rt-icon v-if="item.isup != undefined" type="svg"
                  :name="item.isup ? 'rt-base-tablearrowup' : 'rt-base-tablearrowdown'"
                  style="color: #1890ff; cursor: pointer;margin-left:6px;"></rt-icon>
                <el-tooltip :disabled="isShowTooltip" :content="item.label" placement="top">
                  <div @click="sortCloumn(item)" style="cursor: pointer; min-width: 0" class="_tabletitle">
                    <span :ref="'refName' + item.prop"> {{ item.label }}</span>
                  </div>
                </el-tooltip>
                <div style="margin-top: 6px" v-if="isOff">
                  <rt-icon type="svg" :name="item.oldvalue && item.oldvalue.length
                      ? 'rt-base-cloumncheck'
                      : 'rt-base-cloumnnocheck'" style="color: #1890ff; cursor: pointer;margin-left:6px;"
                    @click="filterFun(item)"></rt-icon>
                </div>
              </div>
            </template>
            <template  slot-scope="{ row }">
              <!-- 自定义操作列 -->
              <div v-if="item.type === 'slot'">
                <slot :name="'column-' + item.prop" v-bind="{ row }"></slot>
              </div>
              <div class="dbclicksty">
                <span :style="item.isCanJump?'color:#1890ff':''">  {{ item.type == 'lookup' ? row[item.prop] && row[item.prop].name : item.type == 'picklist' ?
                  row[item.prop]
                  &&
                  row[item.prop].text :
                  row[item.prop] }}
                </span>
              </div>
            </template>
          </el-table-column>
        </template>
        <el-table-column width="40">
          <template slot="header" slot-scope="scope">
            <rt-icon type="svg" :name="'rt-base-cloumnnocheck'" style="color: #1890ff; cursor: pointer;margin-left:6px;"
              @click="resetData"></rt-icon>
            <!-- <i class="el-icon-s-筛选 (2).svg" style="color:#1890ff" @click="resetData"></i> -->
          </template>
        </el-table-column>
      </el-table>
      <el-table v-if="autoHeight && needFetch && !headrFilter" ref="table" v-bind="$attrs" :stripe="stripe"
        :data="dataList" :row-key="rowKey" :row-class-name="rowClassNameFn" :cell-class-name="cellClassNameFn"
        :header-row-class-name="headerCls" :border="showBorder"
        :class="['rt-table-item', { 'rt-table-draggable': draggable }]" :header-sticky="isSticky" :loading="loading"
        :show-fix-columns="showFixColumns" :radio="radio" :empty-text="emptyText" :total-record="totalRecord"
        :optimize-fixed="optimizeFixed" v-on="$listeners" @row-click="handleClickTableRow"
        @row-dblclick="rowDblclickHandler" @selection-change="selectItem" @cell-click="handleCellClick"
        :height="tableHeight">
        <template>
          <el-table-column v-if="computedSelected" type="selection" :reserve-selection="computedKeepSelected" width="48"
            @selection-change="handleSelectionChange" />
          <el-table-column v-if="draggable" width="48">
            <div class="rt-move" @click="dragBtnClick">
              <rt-icon name="rt-base-drag" size="24" />
            </div>
          </el-table-column>

        </template>
        <slot />
        <slot slot="empty" name="empty" />
      </el-table>
      <el-table v-else-if="autoHeight && !needFetch && !headrFilter" ref="table" v-bind="$attrs" :stripe="stripe" :data="dataList"
        :row-key="rowKey" :row-class-name="rowClassNameFn" :cell-class-name="cellClassNameFn"
        :header-row-class-name="headerCls" :border="showBorder" :header-sticky="isSticky"
        :show-fix-columns="showFixColumns" :radio="radio" :empty-text="emptyText" :total-record="totalRecord"
        :optimize-fixed="optimizeFixed" class="rt-table-item" v-on="$listeners" @row-click="handleClickTableRow"
        @row-dblclick="rowDblclickHandler" @selection-change="selectItem" @cell-click="handleCellClick">
        <template> 
          <el-table-column v-if="computedSelected" type="selection" :reserve-selection="computedKeepSelected" width="48"
            @selection-change="handleSelectionChange" />
          <el-table-column v-if="draggable" width="48">
            <div class="rt-move" @click="dragBtnClick">
              <rt-icon name="rt-base-drag" size="24" />
            </div>
          </el-table-column>
          <slot />
        </template>
        <slot slot="empty" name="empty" />
      </el-table>
      <el-table v-else-if="!autoHeight && needFetch && !headrFilter" ref="table" v-bind="$attrs" :stripe="stripe" :data="dataList" :row-key="rowKey"
        :row-class-name="rowClassNameFn" :cell-class-name="cellClassNameFn" :header-row-class-name="headerCls"
        :border="showBorder" :header-sticky="isSticky" :show-fix-columns="showFixColumns" :radio="radio"
        :empty-text="emptyText" :total-record="totalRecord" :optimize-fixed="optimizeFixed" class="rt-table-item"
        v-on="$listeners" @row-click="handleClickTableRow" @row-dblclick="rowDblclickHandler"
        @selection-change="selectItem" @cell-click="handleCellClick">
        <template>
          <el-table-column v-if="computedSelected" type="selection" :reserve-selection="computedKeepSelected" width="48"
            @selection-change="handleSelectionChange" />
          <el-table-column v-if="draggable" width="48">
            <div class="rt-move" @click="dragBtnClick">
              <rt-icon name="rt-base-drag" size="24" />
            </div>
          </el-table-column>
          <slot />
        </template>
        <slot slot="empty" name="empty" />
      </el-table>

      <div v-if="hasFooter" ref="tableFooter" :style="footerStyle" :rt-xpc-sticky-bottom="isSticky"
        rt-xpc-sticky-group="rtTableFooter" class="rt-table-footer">
        <div class="rt-table-pagination-scroll">
          <div class="rt-table-pagination-scroll-content">
            <div class="rt-table-pagination-scroll-bar"></div>
          </div>
        </div>
        <div v-if="showPagination" class="rt-table-pagination">
          <!-- v-if="totalRecord > 5" -->
          <rt-pagination :current-page="pageIndex" :is-table-click="true" :page-size="pageSizeTable"
            :page-sizes="pageSizes" :pager-count="pagerCount" :layout="pageLayout" :total="totalRecord"
            :background="computedPageBackground" :small="small" @current-change="handleIndexChange"
            @size-change="handleSizeChange">
          </rt-pagination>
        </div>
        <div class="rt-table-footer__left">
          <slot name="footer-left">
          </slot>
        </div>
        <div class="rt-table-footer__right">
          <slot name="footer-right">
          </slot>
        </div>
        <div class="rt-table-footer__center">
          <slot name="footer-center">
          </slot>
        </div>
      </div>
    </div>
    <RTtableCellEditor v-if="editDisplay" ref="editCell" :key="editCellId" class="rt-table-cell-editor"
      :v-node="editTemplate" :prop="editProp" :row="editRow" :rules="_rules" :style="{
          width: editPosition.width,
          height: editPosition.height,
          transform: `translate(${editPosition.x}px, ${editPosition.y}px)`
        }" @update="handleUpdate" @validate-error="$emit('validate-error')" @hide="hideEditCell"></RTtableCellEditor>
    <!-- 用于模糊搜索的 -->
    <rt-dialog size="small" v-model="filterVisible" :title="columData.label" @confirm="filterConfirm"
      @opened="filterOpened" @dialog-reset="dialogReset">
      <div style="padding:10px">
        <rt-input v-if="columData.type == 'string' || columData.type == 'lookup'" :placeholder="'请输入查询内容'"
          v-model="columData.value" style="width: 320px">
        </rt-input>
        <el-input v-if="columData.type == 'money' || columData.type == 'decimal'" type="number" :placeholder="'请输入查询的值'"
          v-model="columData.value" style="width: 320px">
        </el-input>
        <el-select v-if="columData.type == 'picklist'" multiple v-model="columData.value" clearable
          @visible-change="bindPicklist($event, columData)">
          <el-option v-for="item in options" :key="item.Value" :label="item.Text" :value="item.Value">
          </el-option>
        </el-select>
        <el-select v-if="columData.type == 'bool'" v-model="columData.value" style="margin-left: 20px;" placeholder="请选择">
          <el-option v-for="item in isneednotchannelproduct" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker v-if="columData.type == 'datetime'" v-model="columData.value" type="daterange" align="right"
          unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :value-format="'yyyy-MM-dd'">
        </el-date-picker>
      </div>
    </rt-dialog>
  </div>
</template>

<script>
import { store } from './store';
import ElTable from 'vue-xpc/src/element-ui/packages/table';
import ElTableColumn from 'vue-xpc/src/element-ui/packages/table/src/table-column';
import { stickyItem } from 'vue-xpc/src/mixins/sticky';
import {
  closest,
  getSessionStorage,
  setSessionStorage,
  clearSessionStorage
} from 'vue-xpc/src/utils/util.js';
import RTtableCellEditor from './rtTableCellEditor.vue';

const methods = [
  'clearSelection',
  'toggleRowSelection',
  'toggleMultiRowSelection',
  'toggleAllSelection',
  'toggleRowExpansion',
  'setCurrentRow',
  'clearSort',
  'clearFilter',
  'doLayout',
  'sort'
];

export default {
  name: 'RtTable',
  components: { ElTable, ElTableColumn, RTtableCellEditor },
  mixins: [stickyItem],
  props: {
    /**
     * @public 选中行的背景色
     */
    selectedBgColor: {
      type: String,
      default: 'warning'
    },
    size: {
      type: String,
      default: 'small'
    },
    small: {
      type: Boolean,
      default: true
    },
    /**
     * @public
     * 是否显示分页器
     */
    showPagination: {
      type: Boolean,
      default: true
    },
    /**
     * @public
     * 是否显示边框
     */
    showBorder: {
      type: Boolean,
      default: true
    },
    /**
     * @public
     * 是否支持拖拽
     */
    draggable: {
      type: Boolean,
      default: false
    },
    totalRecord: {
      type: Number,
      default: 0
    },
    fetch: {
      type: Function,
      // required: true
    },
    autoHeight: {
      type: Boolean,
      default: true
    },
    tableHeigth: {
      type: Number,

    },
    sectionable: {
      type: Boolean,
      default: true
    },
    radio: {
      type: Boolean,
      default: false
    },
    stripe: {
      type: Boolean,
      default: false
    },
    pageLayout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    // 表格分页默认不加背景色
    pageBackground: {
      type: Boolean,
      default: false
    },
    pagerCount: Number,
    pageSize: {
      type: Number,
      default: 20
    },
    defaultPageIndex: {
      type: Number,
      default: 1
    },
    listPage: {
      type: Boolean,
      default: false
    },
    sticky: {
      type: Boolean,
      default: false
    },
    // header部分的字重，可选值  primary/medium/bold
    headerWeight: {
      type: String,
      default: 'primary'
    },
    // footer 内间距, 【normal-默认、small、large、自定义数值】
    footerPadding: {
      type: [String, Number],
      default: 'small'
    },
    // header 内间距, 【normal-默认、small、large、自定义数值】
    headerPadding: {
      type: [String, Number],
      default: 'normal'
    },
    needFetch: {
      type: Boolean,
      default: true
    },
    noNeedfetchData: {
      type: Array,
      default: () => {
        return []
      }
    },
    tableHeader: {
      type: Array,
      default: () => {
        return []
      }
    },
    headrFilter: {
      type: Boolean,
      default: false
    },
    rowKey: [String, Function],
    // 是否允许行点击选中
    enableRowClick: {
      type: Function,
      default: (row, column, event) => {
        const BOUNDARY_TAGS = ['TR', 'TD', 'TH'];
        const BOUNDARY_CLASSES = ['cell'];
        const INTERACTIVE_TAGS = ['INPUT', 'TEXTAREA', 'BUTTON'];
        const INTERACTIVE_CLASSES = [
          'rt-time-picker',
          'rt-date-picker',
          'rt-input',
          'rt-picklist',
          'rt-radio-group',
          'rt-radio',
          'rt-checkbox-group',
          'rt-checkbox',
          'rt-lookup',
          'rt-input-number',
          'rt-switch'
        ];

        /**
         * 当前点击组件是否为交互型组件
         */
        const isInteractiveComponent = node => {
          // 是否tagName在范围内
          if (INTERACTIVE_TAGS.includes(node.tagName.toUpperCase())) {
            return true;
          }

          // 是否className在范围内
          if (INTERACTIVE_CLASSES.some(cls => node.classList.contains(cls))) {
            return true;
          }

          // 如果父节点已遍历到cell或td、tr、th，则停止查找
          const parentNode = node.parentNode;
          if (
            parentNode ||
            BOUNDARY_TAGS.includes(parentNode.tagName.toUpperCase()) ||
            BOUNDARY_CLASSES.some(cls => parentNode.classList.contains(cls))
          ) {
            return false;
          }

          return isInteractiveComponent(parentNode);
        };

        if (event && event.target) {
          return !isInteractiveComponent(event.target);
        }

        return true;
      }
    },
    /**
     * @public 是否在数据更新之后保留之前选中的数据
     */
    keepSelected: {
      type: Boolean,
      default: true
    },
    // 支持最后一次阅读
    autoLastVisitedRow: {
      type: Boolean,
      default: false
    },
    lastVisitedBgColor: {
      type: String,
      default: 'primary'
    },
    rowClassName: {
      type: [Function, String]
    },
    cellClassName: {
      type: [Function, String]
    },
    rules: {
      type: [Array, Object]
    },
    editPrefix: {
      type: String,
      default: '_edit_'
    },
    optimizeFixed: {
      type: [Boolean, Number],
      default: 20
    },
    emptyText: {
      type: String
    },
  },
  provide() {
    return {
      xpcPaginationContainer: this
    };
  },
  data() {
    return {
      isShowTooltip: true,
      isneednotchannelproduct: [{
        value: true,
        label: "是"
      },
      {
        value: false,
        label: "否"
      },
      ],
      pageIndex: this.defaultPageIndex,
      dataList: [],
      pageSizes: [5, 10, 20, 30, 40, 50],
      state: store.state,
      loading: false,
      pageSizeTable: this.pageSize,
      scrollTop: 0,
      body: null,
      multipleSelection: [], // 表格被选中的内容
      isSticky: false,
      lastVisitedRow: undefined,
      showFixColumns: false,
      editTarget: null,
      editTargetResizeOb: null,
      editTemplate: null,
      editPosition: { width: 0, height: 0, x: 0, y: 0 },
      editDisplay: false,
      editProp: '',
      editRow: {},
      editCellId: '',
      editType: '',
      hasMouseUpEvent: false,
      editColumn: [], // 可编辑列
      tableHeight: 0,
      isOff: false,
      filterSearch: '',
      filterVisible: false,
      columData: {},
      selectedValue: {},
      temp: "",
      options: [],
      filterstr: [],
      detailFunObj:[],//判断是否能跳转
    };
  },
  computed: {
    // 定义 header 内间距
    headerStyle() {
      if (this.headerPadding === 'normal') {
        return { padding: this.SCSS_VARIABLES.DOUBLE_GAP };
      }
      if (this.headerPadding === 'small') {
        return { padding: this.SCSS_VARIABLES.GAP };
      }
      if (this.headerPadding === 'large') {
        return { padding: this.SCSS_VARIABLES.TRIPLE_GAP };
      } else {
        let padding = (this.headerPadding + '').endsWith('px')
          ? this.headerPadding
          : this.headerPadding + 'px';
        return { padding: padding };
      }
    },
    // 定义 footer 内间距
    footerStyle() {
      const style = {};
      if (this.footerPadding === 'normal') {
        style.padding = this.SCSS_VARIABLES.DOUBLE_GAP;
      } else if (this.footerPadding === 'small') {
        style.padding = this.SCSS_VARIABLES.GAP;
      } else if (this.footerPadding === 'large') {
        style.padding = this.SCSS_VARIABLES.TRIPLE_GAP;
      } else {
        let padding = (this.footerPadding + '').endsWith('px')
          ? this.footerPadding
          : this.footerPadding + 'px';
        style.padding = padding;
      }

      if (this.totalRecord <= 5) {
        style.padding = 0;
      }

      return style;
    },
    // 处理方式待定 - 分页设计稿确认再处理，
    computedPageBackground() {
      if (this.small) return false;
      else return this.pageBackground;
    },
    hasHeader() {
      return (
        !!this.$slots.header ||
        this.$slots['header-left'] ||
        this.$slots['header-center'] ||
        this.$slots['header-right']
      );
    },
    hasFooter() {
      return (
        !!this.showPagination ||
        !!this.$slots['footer-left'] ||
        this.$slots['footer-center'] ||
        this.$slots['footer-right']
      );
    },
    total() {
      return this.$tx(
        `共 ${this.totalRecord} 条记录`,
        'xpc.common.totalRecords',
        { count: this.totalRecord }
      );
    },
    headerCls() {
      return [`header-weight--${this.headerWeight}`].join(' ');
    },
    // 验证row-key
    computedKeepSelected() {
      return !!(this.keepSelected && this.rowKey);
    },
    computedSelected() {
      return !this.editColumn.length && this.sectionable;
    },
    _rules() {
      let obj = {};
      Object.keys(this.rules).forEach(item => {
        obj[this.editPrefix + item] = this.rules[item];
      });
      return obj;
    }
  },
  watch: {
    editTarget(val, oldVal) {
      if (typeof ResizeObserver === 'function') {
        if (this.editTargetResizeOb) {
          this.editTargetResizeOb.unobserve(oldVal);
        }

        this.editTargetResizeOb = new ResizeObserver(() => {
          if (val) {
            this.editPosition.width = val.getBoundingClientRect().width;
          }
        });

        this.editTargetResizeOb.observe(val);
      }
    },
    noNeedfetchData(val, oldVal) {
      // if (!this.needFetch) {
      this.dataList = val
      // }
    },
    tableHeader(val, oldVal) {
      console.log('this.tableHeaderthis.tableHeader',this.tableHeader);
      if(this.tableHeader && this.tableHeader.length){
      // this.goDetailFun = this.tableHeader[0].handleView
      this.detailFunObj = this.tableHeader.filter(fi=>{
        if(fi.isCanJump){
          return fi
        }
      })
      console.log('this.detailFunObj',this.detailFunObj)
    }
    },
    // if (!this.needFetch) {
    //   this.dataList = resp || [];
    //   return
    // }
  },
  mounted() {
    if (typeof ResizeObserver === 'function') {
      const resizeOb = new ResizeObserver(() => {
        this.$refs.table && this.$refs.table.doLayout();
        this.appBodyScrollHandler();
      });
      let tableBody;
      if (this.$refs.table.$el) {
        const tableWrapper = this.$refs.table.$el.querySelector(
          '.el-table__body-wrapper'
        );
        tableBody = tableWrapper.querySelector('table.el-table__body');
        //
        if (tableBody) {
          resizeOb.observe(tableBody);
        }
      }
      this.$once('hook:beforeDestroy', () => {
        resizeOb.unobserve(tableBody);
        this.removeHorizontalListener();
      });
    }
    this.loadData();
    
    this.$nextTick(() => {
      // 文档显示区域的高度 - 表格距离浏览器顶部的距离 - 表格距离浏览器底部的距离
      if (this.$refs.table && this.$refs.table.$el.offsetTop) {
        let d = 250;
        if (this.totalRecord < 5) {
          d = 240
        } else {
          d = 260
        }
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - d;
        console.log(' this.tableHeight', this.tableHeight)
        // this.$refs.table.height = this.tableHeight
        // this.tableHeight = 0
        // this.$refs.tableContentRef.setAttribute("height", 0);
        this.$refs.tableContentRef.removeAttribute('height')
        this.$refs.table.doLayout()
        // this.roll()
      }
      // if (this.$refs.table && this.$refs.table.$el.offsetTop) {
      //   this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 220;
      //   console.log(' this.tableHeight', this.tableHeight)

      //   this.$refs.table.doLayout()
      //   // this.roll()
      // }
      this.$slots.default.forEach(item => {
        if (item.data && item.data.scopedSlots && item.data.scopedSlots.edit) {
          const columnName = item.componentOptions.propsData.prop;
          if (!this.editColumn.includes(columnName)) {
            this.editColumn.push(columnName);
          }
        }
      });

      // 将 elementui table 组件原生方法附加在 rtTable 上面
      methods.forEach(method => {
        this[method] = this.$refs.table[method];
      });
      this.getLastVisitedRowByStorage();

      // 适配mac和window，因为ele在table最后添加了一个gutter，在window上会显示
      // css选择器无法选取指定class名的最后一个元素，故而使用js添加一个特殊className操作
      let columns = this.$el.getElementsByClassName('is-leaf');

      if (columns.length > 0) {
        let tagColumn = columns[columns.length - 1];
        tagColumn.classList.add('the-last-one');
      }
      this.scrollTop = 0;
      if (this.rtXpcStickyContainer) {
        this.appBody = this.rtXpcStickyContainer.getContainer();
      } else {
        this.appBody =
          closest(this.$refs.tableRef, '[rt-xpc-sticky-container]') ||
          document.querySelector('[rt-xpc-sticky-container]') ||
          document.querySelector('.qiankun-content') ||
          document.querySelector('.app-body');
      }

      this.appBodyScrollHandler();
      if (
        closest(this.$refs.tableRef, `[rt-xpc-sticky-container]`) &&
        (this.sticky || this.listPage) &&
        !closest(this.$refs.tableRef, '.el-dialog__wrapper')
      ) {
        this.isSticky = true;
      }
      if (this.isSticky) {
        this.appBody &&
          this.appBody.addEventListener('scroll', this.appBodyScrollHandler);
      } else {
        this.showFixColumns = true;
      }
    });
    this.lastVisitedKey = this.getTableStorageKey('last-visited');
    window.addEventListener('beforeunload', this.clearLastVisitedRow);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.clearLastVisitedRow);
    if (this.editTargetResizeOb) {
      this.editTargetResizeOb.unobserve(this.editTarget);
    }
  },

  methods: {
    // 列拉宽事件
    changeColWidth(nw, ow, col, evt) {
      console.log(nw, ow, col, evt)
      // this.setColumnWidth(col)
    },
    setColumnWidth(column) {
      if (this.realWidth) {
        column.width = this.realWidth;
      }
      if (this.realMinWidth) {
        column.minWidth = this.realMinWidth;
      }
      if (!column.minWidth) {
        column.minWidth = 80;
      }
      column.realWidth = column.width === undefined ? column.minWidth : column.width;
      // column.realWidth = 300
      // console.log('---', this.$refs['refParentName' + column.property])
      // console.log('---', this.$refs['refParentName' + column.property].style)
      // console.log(document.getElementById('refParentName' + column.property))
      // console.log(document.getElementById('refParentName' + column.property).style)
      // this.$refs['refParentName' + column.property].style.width = '300px';
      console.log(column)

      console.log('-=-=', this.$refs['refName' + column.property][0].parentElement.classList)
      this.$nextTick(() => {
        document.getElementById('refParentName' + column.property).style.width = column.realWidth < 160 ? 120 + "px" : column.realWidth + 'px';
        // this.$refs['refName' + column.property][0].parentElement.classList.remove("_tabletitle")
        // this.$refs['refName' + column.property][0].parentElement.classList.add("_tabletitle")
        return column;
      })
    },
    //鼠标移入事件
    onMouseOver(refName) {
      console.log(this.$refs[refName])
      let parentWidth = this.$refs[refName][0].parentNode.offsetWidth;
      let contentWidth = this.$refs[refName][0].offsetWidth;
      // 判断是否开启tooltip功能
      console.log('parentWidth:', parentWidth, 'contentWidth:', contentWidth)
      if (contentWidth > parentWidth) {
        this.isShowTooltip = false;
      } else {
        this.isShowTooltip = true;
      }
    },
    sortCloumn(val) {
      this.$nextTick(() => {
        let isup = !val.isup || false 
        this.$set(val, 'isup', isup)
        let attribute = val.prop
        if (attribute.includes('.')) {
          attribute = attribute.split('.')[0]
        }
        if (this.tableHeader && this.tableHeader.length) {
          this.tableHeader.forEach(h => {
            if (h.prop != val.prop) {
              this.$set(h, 'isup', undefined)
            }
          })
        }
        this.$emit("sort-cloumn", { attribute: attribute, order: val.isup })

      })

    },
    dialogReset() {
      this.columData.value = "";
      this.columData.oldvalue = "";
      this.filterConfirm()
    },
    filterOpened() {
      // if (!this.isOff)
      //   this.columData.value = null
      console.log('this.columData', this.columData)
      if (this.columData.value != this.columData.oldvalue) {
        this.columData.value = this.columData.oldvalue
      }
    },
    filterConfirm() {
      let obj = {}
      let attribute = this.columData.prop
      if (attribute.includes('.')) {
        attribute = attribute.split('.')[0]
      }
      obj.attribute = attribute
      obj.type = this.columData.type
      obj.value = this.columData.value
      this.columData.oldvalue = this.columData.value

      if (this.filterstr && this.filterstr.length) {
        var index = this.filterstr.findIndex(fi => fi.attribute == attribute)
        if (index == -1) {
          this.filterstr.push(obj)
        } else {
          this.filterstr.forEach((e, i, arr) => {
            if (e.attribute == attribute) {
              arr[i].value = obj.value
              console.log('this.filterstr---', this.filterstr)
            }
          })
        }
      } else {
        this.filterstr.push(obj)
      }
      this.$emit("filter-confirm", this.filterstr)
    },
    bindPicklist(e, row) {
      var self = this;
      // "/api/crmpicklist/options/" + this.entity + "/" + this.attribute
      rt.get(
        `api/crmpicklist/options/${row.entity}/${row.attribute}`
      ).then(function (res) {
        self.options = res;
      });

    },
    //筛选条件dialog
    submitfilter() {
      this.filterVisible = false;
      this.columObj.rotate = false;
    },
    closefilterDialog() {
      this.filterVisible = false;
      this.columObj.rotate = false;
    },
    filterhandleQuickSearch() { },
    showFilterDialog(val) {
      this.filterVisible = true
    },
    resetData() {
      this.isOff = !this.isOff
      if (this.tableHeader && this.tableHeader.length) {
        if (this.isOff) {
          this.tableHeader.forEach(h => {
            h.rotate = false
            h.value = ""
            h.oldvalue = null
          })
        } else {
          this.tableHeader.forEach(h => {
            this.$set(h, 'isup', undefined)
          })
        }
      }
      if (!this.isOff) {
        this.filterstr = []
        this.$emit('reset-data', [])
      }
    },
    filterFun(row) {
      console.log('-=-=-=-', row.value)
      if (!row.value)
        row.rotate = !row.rotate;
      this.filterVisible = true;
      this.columData = row
    },
    /**
     * 清空已选项
     */
    clearSelection() {
      this.$refs.table.clearSelection();
    },
    /**
     * 选中项变化时，派发事件传递所有选中项
     * @param {Array} rows 所有选中项
     */
    selectItem(rows) {
      this.$emit('select-item', rows);
    },
    handleClickTableRow(row, column, event) {
      if (
        !this.$xpc.isFunction(this.enableRowClick) ||
        this.enableRowClick(row, column, event) === false
      ) {
        return;
      }
      if (this.computedSelected) {
        this.$refs.table.toggleRowSelection(row);
      }
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows;
    },
    loadData() {
      if (!this.needFetch) return
      this.pageIndex = this.defaultPageIndex;
      // if (this.tableHeader && this.tableHeader.length) {
      //   this.tableHeader.forEach(h => {
      //     this.$set(h, 'isup', undefined)
      //   })
      // }
      // 初始表格数据，判断是否为表格内部分页
      this.fetchData();
    },
    fetchData() {
      let pageIndex, pageSize;
      for (var key in this.$slots) {
        if (key !== 'header' && key !== 'default') {
          const slot = this.$slots[key];
          const params =
            slot &&
            slot[0] &&
            slot[0].child &&
            slot[0].child.getParams &&
            slot[0].child.getParams();
          if (params) {
            pageIndex = params.pageIndex;
            pageSize = params.pageSize;
          }
        }
      }
      this.loading = true;
      this.fetch({
        pageIndex: this.showPagination ? this.pageIndex : pageIndex,
        pageSize: this.showPagination ? this.pageSizeTable : pageSize
      })
        .then(resp => {
          // 处理返回结果
          this.dataList = resp || [];
          // this.dataList = resp.slice(0,4) || [];
          // 通过总数量与pageSize比较来判断是否显示分页
          this.morePages = this.totalRecord > this.pageSizeTable;
          if (this.dataList.length === 0 && this.pageIndex > 1) {
            this.pageIndex = Math.ceil(this.totalRecord / this.pageSizeTable);
            this.fetchData();
            return Promise.reject(new Error());
          }
          this.$nextTick(() => {
            this.appBodyScrollHandler();
          });
        })
        .then(() => {
          if (this.autoHeight) {
            this.$nextTick(() => {
              this.updateHeight();
              this.loading = false;
              this.$emit('load-complete');
            });
          } else {
            this.loading = false;
            this.$emit('load-complete');
          }
        })
        .finally(() => {
          this.$setTimeout(() => {
            this.showFixColumns = true;
          }, 100);
        });
    },
    handleSizeChange(val) {
      this.pageSizeTable = val;
      this.pageIndex = 1;
      this.$emit('changesize', val);
      // this.fetchData();
    },
    handleIndexChange(val) {
      this.pageIndex = val;
      this.$emit('changeindex', val);
      // this.fetchData();
    },
    updateHeight() {
      store.UPDATE_TABLE_HEIGHT();
    },
    /**
     * @deprecated
     * 方法已废弃
     */
    computedScroll() {
      // 列表页滑动
      // 如果滑动就固定在底部
      this.$xpc.deprecatedLog(
        'rtTable',
        'computedScroll',
        'appBodyScrollHandler',
        'fn'
      );
    },
    /**
     * @deprecated
     * 方法已废弃
     */
    handleScroll() {
      this.$xpc.deprecatedLog(
        'rtTable',
        'handleScroll',
        'appBodyScrollHandler',
        'fn'
      );
    },
    /**
     * appBody 滚动处理
     */
    appBodyScrollHandler() {
      if (this.isSticky) {
        this.controlStickyTablePagination();
        this.addHorizontalListener();
      }
    },
    /**
     * 控制吸底的分页器显隐
     */
    controlStickyTablePagination() {
      const tableFooter =
        this.$refs.tableRef &&
        this.$refs.tableRef.querySelector('.rt-table-footer');
      const pagination =
        tableFooter && tableFooter.querySelector('.rt-table-pagination');
      const tableContent = this.$refs.tableContentRef;
      if (!pagination || !tableFooter || !tableContent) {
        return;
      }

      const tableScroll = this.$refs.tableRef.querySelector(
        '.el-table__body-wrapper'
      );
      const tableBody = tableScroll.querySelector('table');
      const offsetWidth = Math.max(tableScroll.getBoundingClientRect().width, tableBody.getBoundingClientRect().width)
      const paginationScrollBar = tableFooter.querySelector(
        '.rt-table-pagination-scroll-bar'
      );
      // 说明不应该有滚动条
      if (tableScroll.getAttribute('class').includes('is-scrolling-none')) {
        paginationScrollBar.style.width = '100%';
      } else {
        paginationScrollBar.style.width = Math.floor(offsetWidth) + 'px';
      }

      // 给吸底的滚动条设置与表格相同的宽度
    },
    /**
     * @private 分页器滚动条的监听函数
     */
    paginationScrollListener() {
      const tableFooter =
        this.$refs.tableRef &&
        this.$refs.tableRef.querySelector('.rt-table-footer');
      const tableScroll =
        this.$refs.tableRef &&
        this.$refs.tableRef.querySelector('.el-table__body-wrapper');
      if (!tableFooter) {
        return;
      }
      const paginationScroll = tableFooter.querySelector(
        '.rt-table-pagination-scroll-content'
      );
      tableScroll.scrollLeft = paginationScroll.scrollLeft;
    },
    /**
     * @private 表格横向滚动监听函数
     */
    tableScrollListener() {
      const tableFooter =
        this.$refs.tableRef &&
        this.$refs.tableRef.querySelector('.rt-table-footer');

      const tableScroll =
        this.$refs.tableRef &&
        this.$refs.tableRef.querySelector('.el-table__body-wrapper');
      if (!tableFooter) {
        return;
      }
      const paginationScroll = tableFooter.querySelector(
        '.rt-table-pagination-scroll-content'
      );

      paginationScroll.scrollLeft = tableScroll.scrollLeft;
    },
    /**
     * @private 添加横向滚动的事件
     */
    addHorizontalListener() {
      const tableFooter =
        this.$refs.tableRef &&
        this.$refs.tableRef.querySelector('.rt-table-footer');

      const tableScroll =
        this.$refs.tableRef &&
        this.$refs.tableRef.querySelector('.el-table__body-wrapper');
      if (!tableFooter) {
        return;
      }
      const paginationScroll = tableFooter.querySelector(
        '.rt-table-pagination-scroll-content'
      );

      paginationScroll.addEventListener(
        'scroll',
        this.paginationScrollListener
      );
      tableScroll.addEventListener('scroll', this.tableScrollListener);
    },
    /**
     * @private 移除横向滚动的监听事件
     */
    removeHorizontalListener() {
      const tableFooter =
        this.$refs.tableRef &&
        this.$refs.tableRef.querySelector('.rt-table-footer');
      const tableScroll =
        this.$refs.tableRef &&
        this.$refs.tableRef.querySelector('.el-table__body-wrapper');
      if (!tableFooter) {
        return;
      }
      const paginationScroll = tableFooter.querySelector(
        '.rt-table-pagination-scroll-content'
      );

      paginationScroll.removeEventListener(
        'scroll',
        this.paginationScrollListener
      );
      tableScroll.removeEventListener('scroll', this.tableScrollListener);
    },
    dragBtnClick() {
      console.log('未安装拖拽插件');
    },
    rowClassNameFn(row, rowIndex) {
      let className = `selected-bg-color-${this.selectedBgColor} `;
      if (this.rowClassName) {
        if (typeof this.rowClassName === 'function') {
          const cn = this.rowClassName(row.row, rowIndex);
          className += `${cn} `;
        } else {
          className += `${this.rowClassName} `;
        }
      }

      return className;
    },
    cellClassNameFn({ row, column, rowIndex, columnIndex }) {
      let className = ``;
      if (this.cellClassName) {
        if (typeof this.cellClassName === 'function') {
          const cn = this.cellClassName(row, rowIndex);
          className += `${cn} `;
        } else {
          className += `${this.cellClassName} `;
        }
      }

      if (this.lastVisitedRow && this.equalsRow(row, this.lastVisitedRow)) {
        className += `rt-xpc-bg-${this.lastVisitedBgColor}-light `;
      }

      return className;
    },
    rowDblclickHandler(row, column, event) {
      if (this.autoLastVisitedRow) {
        this.addLastVisitedRow(row);
      }
    },
    addLastVisitedRow(d) {
      this.setLastVisitedRowByStorage(d);
      this.lastVisitedRow = d;
    },
    equalsRow(row1, row2) {
      if (this.rowKey) {
        if (typeof this.rowKey !== 'function') {
          return row1[this.rowKey] === row2[this.rowKey];
        } else {
          return this.rowKey(row1) === this.rowKey(row2);
        }
      } else {
        return row1 === row2;
      }
    },
    getTableStorageKey(suffix) {
      let path = '';
      let key = '';
      if (this.$route) {
        path = this.$route.path;
      } else {
        path = location.href;
      }
      const nodes = document.querySelectorAll('.rt-table');
      if (nodes && nodes.length > 0) {
        nodes.forEach((node, index) => {
          if (node === this.$refs.tableRef) {
            key = `${path}-rt-table-${index}-${suffix}`;
          }
        });
      }

      return key;
    },
    getLastVisitedRowByStorage() {
      if (this.lastVisitedKey) {
        const row = getSessionStorage(this.lastVisitedKey);
        if (row) {
          this.addLastVisitedRow(row);
        }
      }
    },
    setLastVisitedRowByStorage(row) {
      if (this.lastVisitedKey) {
        setSessionStorage(this.lastVisitedKey, row);
      }
    },
    clearLastVisitedRow() {
      this.lastVisitedRow = undefined;
      clearSessionStorage(this.lastVisitedKey);
    },

    handleCellClick(row, column, cell, event) {
      // 单机单元格进入详情 
      if(this.detailFunObj && this.detailFunObj.length){
        let data = this.detailFunObj.find(fin=>{
          return fin.prop == column.property
        })
        if(data){
          data.handleView(row)
        }
      }
      // 判断是否为可编辑单元格
      if (!column.renderEditCell) return;
      // 如果可编辑框已存在，且存在校验失败的情况，不允许点击
      if (
        this.editDisplay &&
        !!this.$refs.editCell.$el.querySelector('.is-error')
      ) {
        return;
      }
      // 临时挂载可编辑单元格数据
      row[this.editPrefix + column.property] = JSON.parse(
        JSON.stringify(row[column.property])
      );
      let target = closest(event.target, '.el-table__cell') || event.target;
      this.editTarget = target;
      const header = this.$refs.tableRef.querySelector(
        '.el-table__header-wrapper'
      );
      if (!this.hasMouseUpEvent) {
        document.addEventListener('keyup', this.handleKeyUp);
        this.hasMouseUpEvent = true;
      }

      this.editTemplate = column.renderEditCell;
      this.editPosition = {
        x: target.offsetLeft,
        y: target.offsetTop + header.offsetHeight,
        width: target.offsetWidth,
        height: target.offsetHeight
      };
      this.editDisplay = true;
      this.editProp = this.editPrefix + column.property;
      this.editRow = row;
      this.editCellId = rt.newUUID();
    },

    handleKeyUp(e) {
      const theEvent = e || window.event;
      const code = theEvent.keyCode || theEvent.which || theEvent.charCode;
      if (code === 13) {
        this.handleUpdate();
        return false;
      }
    },

    handleUpdate() {
      if (
        !this.editColumn.find(item => this.editPrefix + item === this.editProp)
      ) {
        return;
      }
      if (this.hasMouseUpEvent) {
        new Promise(resolve => {
          const done = () => resolve(true);
          const stop = () => resolve(false);
          this.$emit(
            'update',
            {
              prop: this.editProp.replace(this.editPrefix, ''),
              value: this.editRow[this.editProp],
              row: this.editRow
            },
            done,
            stop
          );
        }).then(needClose => needClose && this.hideEditCell());
      }
    },

    hideEditCell() {
      this.dataList.forEach(item => {
        Object.keys(item).forEach(n => {
          if (n.startsWith(this.editPrefix)) {
            delete item[n];
          }
        });
      });
      document.removeEventListener('keyup', this.handleKeyUp);
      this.hasMouseUpEvent = false;
      this.editDisplay = false;
    }
  }
};
</script>
<style>
.el-popper {
  z-index: 8888 !important;
}

.el-select /deep/ .select-popper {
  z-index: 8888 !important;
  top: auto !important;
  left: auto !important
}
</style>
<style lang="scss" scoped>
.refParentStyle {
  display: flex;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
  width: 120px
}

._tabletitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

._tabletitle2 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cus-delete-btn:focus {
  color: inherit;
}

.rtportal .el-table .el-table__row .cell .el-button--text {
  font-size: 13px;
}

.dialog-seaarch {
  float: right;
  margin: 10px 20px 10px 0;
}

.el-icon-caret-bottom-transition {
  transition: all 0.8s;
}

.go-top {
  transform: rotate(-180deg);
  transition: all 1s;
}

.table-label {
  display: flex;
  align-content: center;
  justify-content: flex-start;
}

.el-dialog__footer {
  z-index: 30000 !important;
}

.el-table__fixed,
.el-table__fixed-right {
  box-shadow: none !important;
}

.el-table__fixed::before,
.el-table__fixed-right::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: #fff;
  z-index: 4;
}

.dbclicksty {
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}  
.dbclicksty:hover {
  // font-weight: 600;
}

.go-top {
  transform: rotate(-180deg);
  transition: all 0.5s;
}
</style>


// WEBPACK FOOTER //
// rtTable.vue?0f130dcd